import api from './api';

export const batchService = {
  // Get all batches
  getBatches: async () => {
    const response = await api.get('/admin/batches');
    return response.data;
  },

  // Get single batch
  getBatch: async (id) => {
    const response = await api.get(`/admin/batches/${id}`);
    return response.data;
  },

  // Create new batch
  createBatch: async (batchData) => {
    const response = await api.post('/admin/batches', batchData);
    return response.data;
  },

  // Update batch
  updateBatch: async (id, batchData) => {
    const response = await api.put(`/admin/batches/${id}`, batchData);
    return response.data;
  },

  // Create next batch automatically
  createNextBatch: async () => {
    const response = await api.post('/admin/batches/create-next');
    return response.data;
  },

  // Toggle admin stop
  toggleAdminStop: async (id) => {
    const response = await api.post(`/admin/batches/${id}/toggle-stop`);
    return response.data;
  },

  // Get batch settings
  getSettings: async () => {
    const response = await api.get('/admin/batch-settings');
    return response.data;
  },

  // Update batch settings
  updateSettings: async (settings) => {
    const response = await api.put('/admin/batch-settings', settings);
    return response.data;
  }
};